export const removeExtraSpaces = (str: string): string =>
  str.replace(/\s+/g, " ").trim();
